import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=2901076a&scoped=true&"
import script from "./UserPage.vue?vue&type=script&lang=js&"
export * from "./UserPage.vue?vue&type=script&lang=js&"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=2901076a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2901076a",
  null
  
)

export default component.exports